// extracted by css-extract-rspack-plugin
export default {"breadcrumbs":"nBX9MHu36gcvtTy8","link":"fkITvUwLv3shdauv","icon":"iADZ4BrbkGgH42jQ"};